import { AppSliceState } from '@/store/appSlice'

export function getSct(urlStr: string): AppSliceState['sct'] {
  const url = new URL(urlStr)
  const sctParam = url.searchParams.get('sct')
  if (sctParam === null) {
    return null
  }

  const split = sctParam
    .split(',')
    .map((item) => parseInt(item))
    .filter((n) => !Number.isNaN(n))

  if (split.length === 0) {
    return null
  }

  return split
}
